module.exports = __webpack_public_path__ + "static/media/bottom-page-image.a2f6acab.png";